import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'documents-ui/reducers';
import { errorMiddleware } from 'documents-lib/js/middleware/errorMiddleware';
const composeWithEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const createStoreWithMiddleware = composeWithEnhancers(applyMiddleware(thunk, errorMiddleware))(createStore);
export default function configureStore(initialState) {
  return createStoreWithMiddleware(rootReducer, initialState);
}